import { useHistory } from 'react-router-dom';
import { useCurrentLetter } from 'assets/js/pages/engage/letters/useCurrentLetter';
import { useLetterMeta } from 'assets/js/pages/engage/letters/useLetterMeta';
import { transformSavedFilterGroups } from 'components/filter/filters-next/downstream';
import { useFiltersCache } from 'contexts/useFiltersCache';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { OutboundFilters } from 'types/request';

const useLetterRecipientContactFilter = () => {
    const history = useHistory();
    const { accountId } = useCurrentAccount();
    const { data: letter } = useCurrentLetter();
    const updateFilterCache = useFiltersCache(state => state.updateFiltersNextByKey);
    const { isOnConfirm } = useLetterMeta();

    return () => {
        if (isOnConfirm) {
            history.push(`/accounts/${accountId}/engage/letters/draft/${letter.id}/edit/filters`);
        } else {
            const filters: OutboundFilters = [
                {
                    type: 'or',
                    children: {
                        mailingsRecipients: [
                            {
                                value: [letter.id],
                                type: 'and',
                                operator: '=',
                            },
                        ],
                    },
                },
            ];
            updateFilterCache('contacts', transformSavedFilterGroups(filters));
            history.push(`/accounts/${accountId}/contacts`);
        }
    };
};

export { useLetterRecipientContactFilter };
